import * as React from "react";
const SvgDecreasingVolume = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	...props
}, /* @__PURE__ */ React.createElement("rect", {
	width: 3,
	height: 6,
	transform: "matrix(-1 0 0 1 36.5 31)"
}), /* @__PURE__ */ React.createElement("rect", {
	width: 3,
	height: 8,
	transform: "matrix(-1 0 0 1 30.5 29)"
}), /* @__PURE__ */ React.createElement("rect", {
	width: 3,
	height: 12,
	transform: "matrix(-1 0 0 1 24.5 25)"
}), /* @__PURE__ */ React.createElement("rect", {
	width: 3,
	height: 18,
	transform: "matrix(-1 0 0 1 18.5 19)"
}), /* @__PURE__ */ React.createElement("rect", {
	width: 3,
	height: 26,
	transform: "matrix(-1 0 0 1 12.5 11)"
}), /* @__PURE__ */ React.createElement("rect", {
	width: 3,
	height: 34,
	transform: "matrix(-1 0 0 1 6.5 3)"
}));
export default SvgDecreasingVolume;
